module.exports = __webpack_public_path__ + "img/gplogo.530f19af.png";